module.exports = __webpack_public_path__ + "img/approve.66deb965.png";